<template>
  <b-container>
    <b-card id="login-form" class="mx-auto mt-2 mb-2" title="Login">
      <b-alert v-if="false" variant="info" class="pt-2 pb-2" show>
        <p class="mb-0">Currently this app is for friends only...</p>
        <small><i>Drop me a line if you would like to contribute some POIs.</i></small>
      </b-alert>
      <b-form @submit.prevent="onSubmit" class="justify-content-center">
        <b-form-group id="email" label="e-mail:" label-for="email">
          <b-form-input
            id="email"
            type="email"
            name="email"
            placeholder="e-mail..."
            maxlength="150"
            autocomplete="email"
            value
            required
            autofocus
            v-model="form.email"
          />
        </b-form-group>
        <b-form-group id="password" label="Password:" label-for="input-1">
          <b-form-input
            id="password"
            type="password"
            placeholder="password..."
            autocomplete="current-password"
            required
            v-model="form.password"
          />
        </b-form-group>
        <b-button variant="primary" type="submit">
          Log In
        </b-button>
        <b-alert v-if="error" variant="danger" class="mt-3 mb-0" show>{{ error }}</b-alert>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LoginView',
  computed: {
    ...mapGetters({ user: 'auth/user' }),
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      error: null,
    };
  },
  methods: {
    onSubmit() {
      this.$store
        .dispatch('auth/login', { form: this.form })
        .then(() => {
          this.$router.push(this.returnUrl);
        })
        .catch(err => (this.error = err));
    },
  },
  created() {
    // redirect to home if already logged in
    if (this.user.loggedIn) {
      return this.$router.push({ name: 'home' });
    }
    // anonymous: get return url from route parameters or default to '/'
    this.returnUrl = this.$route.query.returnUrl || '/';
  },
};
</script>

<style scoped>
#login-form {
  max-width: 500px;
  min-width: 350px;
}
</style>
